import PropTypes from "prop-types";
import styles from "./index.css";

const DeliveryBanner = ({ bannerConfig }) => {
  if (!bannerConfig) return null;

  const { bannerText, linkText, linkUrl } = bannerConfig;

  return (
    <div
      className={styles.container}
      role="region"
      aria-label="Delivery information"
    >
      <div className={styles.body}>
        <p>
          {bannerText}{" "}
          <a
            href={linkUrl}
            className={styles.link}
            target="_blank"
            rel="noopener noreferrer"
          >
            {linkText}
          </a>
        </p>
      </div>
    </div>
  );
};

DeliveryBanner.propTypes = {
  bannerConfig: PropTypes.shape({
    bannerText: PropTypes.string.isRequired,
    linkText: PropTypes.string.isRequired,
    linkUrl: PropTypes.string.isRequired,
  }),
};

export default DeliveryBanner;
